{
  "sections": "Разделы",
  "group": {
    "monitoring": "Мониторинг",
    "access": "Доступ",
    "administration": "Администрирование"
  },
  "overview": "Обзор",
  "map": "Карта сети",
  "nodes": "Узлы и мониторы",
  "events": "События",
  "perf": "Замер карты",
  "vnc": "VNC-консоль",
  "ssh": "Терминал",
  "video": "Видеостена",
  "archive": "Видео архив",
  "sessions": "Активные сессии",
  "sites": "Площадки",
  "credentials": "Учётные данные",
  "agents": "Агенты",
  "notifications": "Уведомления",
  "users": "Пользователи",
  "audit": "Журнал аудита",
  "collapse": "Свернуть",
  "collapseMenu": "Свернуть меню",
  "expandMenu": "Развернуть меню",
  "closeMenu": "Закрыть меню",
  "plannedHint": "{{label}} — раздел появится в следующих фазах",
  "soon": "скоро",
  "noRoles": "без ролей",
  "you": "Вы",
  "roles": "Роли",
  "version": "v{{version}} · фаза {{phase}}"
}
